import { useHelpArticles } from '../hooks/useHelpArticles'
import { isArticleOnSurface } from '../surfaces'
import type { Surface } from '../types'

const MAX_ARTICLES = 6

interface ScreenSuggestionsProps {
  surface: Surface
  onOpenArticle: (slug: string) => void
}

// The reader's opening state: the articles for the screen the user is on, so the
// pane is useful before any question is asked.
export function ScreenSuggestions({
  surface,
  onOpenArticle,
}: ScreenSuggestionsProps) {
  const { articles } = useHelpArticles()
  const onScreen = articles.filter((article) =>
    isArticleOnSurface(article.surfaces, surface.key),
  )
  const shown = (onScreen.length > 0 ? onScreen : articles).slice(
    0,
    MAX_ARTICLES,
  )

  return (
    <div className="p-6">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-blue-4">
        Articles for {surface.label}
      </p>
      <div className="flex flex-col gap-2.5">
        {shown.map((article) => (
          <button
            key={article.slug}
            type="button"
            onClick={() => onOpenArticle(article.slug)}
            className="cursor-pointer rounded-xl border border-border bg-white p-4 text-left transition-colors hover:border-brand/40 hover:bg-brand/5"
          >
            <p className="text-sm font-semibold text-blue-7 text-pretty">
              {article.title}
            </p>
            {article.tldr && (
              <p className="mt-1 text-[0.8rem] leading-snug text-blue-5 text-pretty">
                {article.tldr}
              </p>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
